import script from "./FrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"

import "./FrequenciaEncontro.vue?vue&type=style&index=0&id=bb1bf20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1bf20c"]])

export default __exports__